import React, { FC } from 'react';
import { usePapaParse } from 'react-papaparse';

import { CSVImportComponent } from '../../CSVImport/CSVImportComponent';
import { CourseMappingExportModel } from '../CourseMapping.interfaces';
import { CSVConverterProviderProps } from './CSVConverterProvider.interfaces';
import { toImportRows } from './csvRow.utils';

export const CSVConverterProvider: FC<CSVConverterProviderProps> = (props) => {
  const { inputRef, complete, error } = props;
  const { readString } = usePapaParse();

  const handleFileSelected = (files: FileList | null) => {
    if (!files) {
      return;
    }
    const fileReader = new FileReader();
    fileReader.onload = () => {
      const text = (fileReader.result as string).trim();
      readString<CourseMappingExportModel>(text, {
        header: true,
        worker: true,
        delimiter: ';',
        complete: (results) => {
          const outcome = toImportRows(results.meta.fields, results.data);
          if ('error' in outcome) {
            error?.(outcome.error);
          } else {
            complete?.(outcome.rows);
          }
        },
      });
    };
    fileReader.readAsText(files[0]);
  };

  return <CSVImportComponent filesSelected={handleFileSelected} inputRef={inputRef} />;
};
